import React from 'react';
import i18n from '@/shared/i18n/i18n';

const KYCRedirect: React.FC = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-revving-background-muted dark:bg-darkRevving-background-muted">
      <div className="text-revving-content-strong dark:text-darkRevving-content-strong">
        {i18n.t('kyc.redirect')}
      </div>
    </div>
  );
};

export default KYCRedirect;
